var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0826 17.0784L15.1367 22.0243",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0643 21.9904L15.1641 17.0902",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7777 10.9137C12.6777 10.9037 12.5577 10.9037 12.4477 10.9137C10.0677 10.8337 8.17773 8.8837 8.17773 6.4837C8.17773 4.0337 10.1577 2.0437 12.6177 2.0437C15.0677 2.0437 17.0577 4.0337 17.0577 6.4837C17.0477 8.8837 15.1577 10.8337 12.7777 10.9137Z",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.618 14.6038C14.868 12.7638 10.358 12.7638 7.60797 14.6038C5.18797 16.2138 5.18797 18.8538 7.60797 20.4738C8.57755 21.1201 9.75939 21.5395 11.0078 21.7317",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.f397579087255e4f8aab220b23cfc08f.svg";
export { ForwardRef as ReactComponent };